import React, { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import LoginPage from '../auth/LoginPage';
import SetupPage from '../auth/SetupPage';
import ForgotPasswordPage from '../auth/ForgotPasswordPage';
import { SecurityProvider } from '../security/SecurityContext';
import AppContent from './AppContent';

export default function AuthGate() {
  const { user, loading, isSetup } = useAuth();
  const [authView, setAuthView]    = useState('login'); // 'login' | 'setup' | 'forgot'

  if (loading) {
    return (
      <div style={{ minHeight:'100vh', background:'var(--surface-2)', display:'flex', alignItems:'center', justifyContent:'center' }}>
        <div style={{ textAlign:'center', color:'var(--text-muted)' }}>
          <div style={{ width:36,height:36,border:'3px solid var(--brand-blue)',borderTopColor:'transparent',borderRadius:'50%',animation:'spin 0.8s linear infinite',margin:'0 auto 14px' }} />
          <p style={{ fontFamily:'monospace', fontSize:11, letterSpacing:2, textTransform:'uppercase' }}>Initialising Security Module...</p>
          <style>{`@keyframes spin{to{transform:rotate(360deg);}}`}</style>
        </div>
      </div>
    );
  }

  if (!user) {
    if (!isSetup || authView === 'setup') {
      return <SetupPage onSwitchToLogin={() => setAuthView('login')} onDone={(token, username) => { /* login handled inside */ }} />;
    }
    if (authView === 'forgot') {
      return <ForgotPasswordPage onBack={() => setAuthView('login')} />;
    }
    return (
      <LoginPage
        onForgotPassword={() => setAuthView('forgot')}
        onSetup={() => setAuthView('setup')}
      />
    );
  }

  return (
    <SecurityProvider>
      {/* key forces a full unmount+remount on every identity change.
          This guarantees tab state, scroll positions, and all child
          component states reset to initial values for every new login. */}
      <AppContent key={user.username || user.email || user.id || 'user'} />
    </SecurityProvider>
  );
}
